import { render, staticRenderFns } from "./BrochureIndex.vue?vue&type=template&id=28e7299a&scoped=true"
import script from "./BrochureIndex.vue?vue&type=script&lang=js"
export * from "./BrochureIndex.vue?vue&type=script&lang=js"
import style0 from "./BrochureIndex.vue?vue&type=style&index=0&id=28e7299a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.32_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6_oo5wulyvj3zulgczlh6g6gwe5u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e7299a",
  null
  
)

export default component.exports